import useQueryGetBankProvider from '@/modules/bank/api/hooks/useQueryGetBankProvider'
import { useMemo } from 'react'

type BankInfo = {
	bankProvider?: string
	accountName?: string
	accountNumber?: string
}

type BankInfoCellProps = {
	bank?: BankInfo | null
	displayText?: string
}

export default function BankInfoCell({ bank, displayText }: BankInfoCellProps) {
	const { data: bankProviders, isLoading } = useQueryGetBankProvider()

	const bankProviderImageUrl = useMemo(() => {
		if (!bankProviders || isLoading || !bank?.bankProvider) return null

		const matchedProvider = bankProviders.find(
			(provider) => provider.name === bank.bankProvider,
		)

		return matchedProvider?.imageUrl || null
	}, [bankProviders, isLoading, bank?.bankProvider])

	const textToDisplay = useMemo(() => {
		if (displayText) return displayText
		if (!bank) return '-'
		return (
			`${bank.bankProvider || ''} ${bank.accountName || ''} ${bank.accountNumber || ''}`.trim() ||
			'-'
		)
	}, [bank, displayText])

	return (
		<div className="flex items-center gap-2">
			{bankProviderImageUrl && (
				<div className="h-8 w-8 overflow-hidden rounded border">
					<img
						src={bankProviderImageUrl}
						alt="Bank provider"
						className="h-full w-full object-cover"
					/>
				</div>
			)}
			<span>{textToDisplay}</span>
		</div>
	)
}
